import { render, staticRenderFns } from "./PostalcodeTown.vue?vue&type=template&id=67a316b4&"
import script from "./PostalcodeTown.vue?vue&type=script&lang=js&"
export * from "./PostalcodeTown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VAutocomplete,VCol,VIcon,VListItemAction,VListItemContent,VListItemTitle,VRow,VSlider,VThemeProvider})
